'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fad';
var iconName = 'portal-enter';
var width = 512;
var height = 512;
var ligatures = [];
var unicode = 'e022';
var svgPathData = ['M512,256c0,141.38477-35.81641,256-80,256-40.78906,0-74.38281-97.75781-79.3125-224.00781H384a32.001,32.001,0,0,0,0-64.002H352.69141C357.625,97.74805,391.21094,0,432,0,476.18359,0,512,114.61523,512,256Z', 'M113.6875,317.47852,98.875,351.99414H32a32.001,32.001,0,0,0,0,64.00195h77.4375a47.9242,47.9242,0,0,0,44.125-29.07812l8.78125-20.5332-10.65625-6.29688A95.3862,95.3862,0,0,1,113.6875,317.47852ZM272,96.00195a48.001,48.001,0,1,0-48-48A48.00237,48.00237,0,0,0,272,96.00195ZM384,223.99023H339.96875l-26.0625-53.25195c-12.5-25.54687-35.46875-44.21875-61.78125-50.9375L181.0625,98.6582a95.69075,95.69075,0,0,0-80.875,17.14258L60.5625,146.207A31.99634,31.99634,0,1,0,99.5,196.99023l39.6875-30.4082c7.65625-5.89062,17.4375-8,25.25-6.14062l14.6875,4.375-37.4375,87.39453A64.16017,64.16017,0,0,0,168,332.52539l84.9375,50.17383L225.5,470.41992a31.96894,31.96894,0,0,0,20.9375,40.0957,31.9422,31.9422,0,0,0,40.125-20.9707l31.625-101.06445a48.16,48.16,0,0,0-21.625-54.39258l-61.25-36.14258,31.3125-78.2832,20.28125,41.43945A48.2689,48.2689,0,0,0,330,287.99219h54a32.001,32.001,0,0,0,0-64.002Z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.faPortalEnter = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = ligatures;
exports.unicode = unicode;
exports.svgPathData = svgPathData;